<template>
  <v-card class="mt-5" flat outlined>
    <v-card-title class="d-flex align-center subtitle-2">
      {{ item.technician_name }}
      <v-spacer></v-spacer>
      <template v-if="item.id">
        {{ item.type == 3 ? "Total" : "Total Commission" }}

        <div class="ml-5">
          <v-text-field
            class="input_35"
            outlined
            hide-details
            @input="updateCommission"
            v-model="item.total_commission"
            dense
          ></v-text-field>
        </div>
      </template>
    </v-card-title>
    <v-data-table
      class="templates-table"
      hide-default-footer
      :items-per-page="-1"
      :items="item.items"
      :headers="headers"
    >
      <template v-slot:item.job_number="{ item }">
        <a :href="`/jobs/${item.id}`" target="_blank">
          {{ item.job_number }}
        </a>
      </template>
      <template v-slot:item.last_name="{ item }">
        {{ getLastName(item) }}
      </template>
      <template v-slot:item.tech_status="{ item }">
        <div :class="getTechClass(item)" v-html="getTechStatus(item)"></div>
      </template>
      <template v-slot:item.invoice="{ item }">
        <v-text-field
          class="input_35"
          outlined
          dense
          @input="updateJob(item, 'invoice')"
          hide-details=""
          v-model="item.invoice"
        />
      </template>
      <template v-slot:item.status="{ item }">
        <div :class="getJobStatusClass(item)">
          {{ getJobStatus(item) }}
        </div>
      </template>
      <!-- <template v-slot:item.how_paid="{ item }">
        <v-select
          class="input_35"
          outlined
          @change="updateJob(item, 'how_paid')"
          dense
          :disabled="!isAdmin"
          item-text="name"
          item-value="name"
          :items="howPaidItems"
          hide-details=""
          v-model="item.how_paid"
        />
      </template> -->
      <template v-slot:item.reimbusements="{ item }">
        <div class="d-flex align-center">
          <v-checkbox
            hide-details
            class="ma-0 pa-0"
            v-model="item.is_cheapo"
            @change="updateJob(item, 'is_cheapo')"
          ></v-checkbox>
          <v-text-field
            class="input_35"
            outlined
            @input="updateJob(item, 'reimbusements')"
            hide-details=""
            dense
            v-model="item.reimbusements"
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.net_sales="{ item }">
        {{ getNetSale(item) }}
      </template>
      <template v-slot:item.technician_commission="{ item }">
        <v-text-field
          class="input_35"
          outlined
          dense
          @input="updateJob(item, 'technician_commission')"
          hide-details=""
          v-model="item.technician_commission"
        />
      </template>
      <template v-slot:item.cheapo_commission="{ item }">
        <v-text-field
          class="input_35"
          dense
          outlined
          @input="updateJob(item, 'cheapo_commission')"
          hide-details=""
          v-model="item.cheapo_commission"
        />
      </template>
      <template v-slot:item.deposited="{ item }">
        <v-select
          class="input_35"
          outlined
          :items="['Yes', 'No']"
          dense
          @change="updateJob(item, 'deposited')"
          hide-details=""
          v-model="item.deposited"
        />
      </template>

      <template v-slot:item.disposition="{ item }">
        <div :class="getDispositionStatus(item)">
          {{ getDisposition(item) }}
        </div>
      </template>
      <template v-slot:item.total="{ item, value }">
        <div :class="getTotalColor(item)">
          {{ value }}
        </div>
      </template>
      <template v-slot:item.technician_total_collected="{ item, value }">
        <div :class="getTotalColor(item)">
          {{ value }}
        </div>
      </template>
      <template v-slot:item.dispatcher="{ item }">
        {{ getDispatcher(item) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import customerModal from "../../assets/js/customer.modal";
import { status } from "../../assets/js/default";
import { customers, dispatch } from "../../assets/js/firebase";
export default {
  props: {
    date: String,
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      jobStatus: status,
    };
  },
  computed: {
    dispositions() {
      return this.$store.getters.dispositions;
    },
    howPaidItems() {
      let item = this.$store.getters.globalFields.find((item) => {
        return item.id == customerModal.HOW_PAID;
      });
      return item instanceof Object ? item.options : [];
    },
    headers() {
      let doc = {
        job_number: "Job #",
        tech_status: "Tech Confirmation",
        invoice: "Invoice #",
        last_name: "CUSTOMER LAST NAME",
        template_name: "Job Type",
        status: "Job Status",
        how_paid: "How Paid",
        total: "Quoted Flat Rate",
        technician_total_collected: "Tech Total Collected",
        charges: "Credit Card Fee $",
        // reimbusements: "Reimbursement $",
        net_sales: "Net Sales $",
        technician_commission: "Tech. Commission",
        cheapo_commission: this.item.type == 3 ? "Cheapo" : "Cheapo Commission",
        disposition: "Disposition",
        deposited: "Deposited",
        dispatcher: "Dispatcher",
      };
      let list = [];
      Object.keys(doc).forEach((value) => {
        let divider = true;
        let width = "100px";
        if (value == "dispatcher") {
          divider = false;
        }
        if (value == "job_number") width = "70px";
        list.push({
          text: doc[value].toUpperCase(),
          divider,
          width,
          value,
        });
      });
      return list;
    },
    users() {
      return this.$store.getters.users;
    },
  },
  methods: {
    getTotalColor({technician_total_collected, total} ) {
      if(!technician_total_collected) return "";
      return technician_total_collected - total == 0 ? '' : 'red--text'
    },
    getDispatcher(item) {
      let user = [...this.users].find((i) => i.email == item.dispatcher);
      return user ? `${user.first_name} ${user.last_name}` : item.dispatcher;
    },
    getNetSale(item) {
      let { total, charges, reimbusements } = item;
      total = parseFloat(total);
      charges = parseFloat(charges);
      reimbusements = parseFloat(reimbusements);
      if (isNaN(total)) total = 0;
      if (isNaN(charges)) charges = 0;
      if (isNaN(reimbusements)) reimbusements = 0;
      return (total - charges - reimbusements).toFixed(2);
    },
    getJobStatusClass({ disposition }) {
      if (disposition == customerModal.DISPOSITION_COMPLETE)
        return "green--text";
      if (disposition == customerModal.DISPOSITION_CANCEL) return "red--text";
      return "";
    },
    getJobStatus({ status }) {
      let item = this.jobStatus.find((item) => {
        return item.value == status;
      });
      return item instanceof Object ? item.name : "";
    },
    getDisposition({ disposition }) {
      let item = this.dispositions.find((item) => {
        return item.id == disposition;
      });
      return item instanceof Object ? item.name : "";
    },
    async updateJob(job, key) {
      const vm = this;
      try {
        let doc = {};
        doc[key] = job[key];
        vm.$emit("onJobUpdate", { job });
        await customers.doc(job.id).update(doc);
      } catch (error) {
        vm.$alert.show(error.message);
      }
    },
    async updateCommission(val) {
      const vm = this;
      try {
        let doc = {};
        doc[`technician_commission.${vm.item.id}`] = val;
        console.log(doc);
        await dispatch.doc(vm.date).update(doc);
      } catch (error) {
        vm.$alert.show(error.message);
      }
    },
    getTechClass({ technician_accept_status }) {
      if (technician_accept_status == "accept") {
        return "green--text";
      }
      if (technician_accept_status == "reject") {
        return "red--text";
      }
      return "";
    },
    getDispositionStatus({ disposition }) {
      if (disposition == customerModal.DISPOSITION_COMPLETE) {
        return "green--text";
      }
      if (disposition == customerModal.DISPOSITION_CANCEL) {
        return "red--text";
      }
      return "";
    },
    getLastName(item) {
      let fields = item.fields || {};
      return fields[customerModal.LAST_NAME];
    },
  },
};
</script>

<style lang="scss"></style>
